// #ux-redesign-start: LockScreenPage rediseñada (Paso 5 — Patients)
// Pantalla 2FA: pide 6 dígitos. Reusa AuthLayout + AuthCard del DS para
// quedar coherente con el resto del flow de auth. La lógica (auto-submit al
// llegar a 6 dígitos via actionCheck2fa) se preserva tal cual.
// ─────────────────────────────────────────────────────────────────────────────

import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslate } from "react-translate";

import { actionCheck2fa } from "store/actions/usersActions";
import useInitialUrl from "hooks/useInitialUrl";

import AuthLayout from "components/Auth/AuthLayout";
import AuthCard from "components/Auth/AuthCard";
import { Input } from "components/ds";

const LockScreenPage = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userReducer);
  const urlDefault = useInitialUrl();
  const t2fa = useTranslate("2fa");
  const tLogin = useTranslate("login-page");

  // eslint-disable-next-line
  const [code, setCode] = useState(null);

  const handleChange = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setCode(value);
    if (value.length === 6) {
      dispatch(actionCheck2fa(value));
    }
  };

  const isAuth = () => {
    if (user.isAuth && user.auth_2fa === true) {
      props.history.push(urlDefault);
    }
  };

  useEffect(() => {
    document.body.classList.add("lock-page");
    isAuth();
    return () => {
      document.body.classList.remove("lock-page");
    };
    // eslint-disable-next-line
  }, []);

  if (!user.auth_2fa) {
    return <Redirect to="/auth" />;
  } else if (user.auth_2fa === "true") {
    return <Redirect to="/admin" />;
  }

  const title = user.name || (tLogin("login") || "");

  return (
    <AuthLayout panelTitle={title} panelSubtitle={t2fa("enter-code") || "2FA"}>
      <AuthCard title={title}>
        <div className="ds-auth__form">
          <Input
            name="code"
            type="number"
            inputMode="numeric"
            label={t2fa("enter-code") || "2FA"}
            placeholder={(t2fa("enter-code") || "2FA") + "..."}
            onChange={handleChange}
            autoFocus
            maxLength={6}
          />
        </div>
      </AuthCard>
    </AuthLayout>
  );
};

export default LockScreenPage;
// #ux-redesign-end
